import i18n from '../config/i18n'
export default {
  adrList: [{
      adr: '1GaHYpWmqAJsqRwrpoNcB8VvgKtSwjcHqt',
      tag: `coins ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '16htvcBNSEA7fZhAdLJphDwQRQJaHpyHTp',
      tag: `ticket ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '1LFqVvGaRpxbEWCEJVpUHAwXnh5Rt591m',
      tag: `hashlock ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '1Q4NhureJxKNBf71d26B9J3fBQoQcfmez2',
      tag: `manage ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '1DzTdTLa5JPpLdNNP2PrV1a6JCtULA7GsT',
      tag: `none ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '14uBEP6LSHKdFvy97pTYRPVPAqij6bteee',
      tag: `multisig ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '1HPkPopVe3ERfvaAgedDtJQ792taZFEHCe',
      tag: `paracross ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '1wvmD6RNHzwhY4eN75WnM6JcaAvNQ4nHx',
      tag: `retrieve ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '12hpJBHybh1mSyCijQ2MQJPk7z7kZ7jnQa',
      tag: `token ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '1BXvgjmBw1aBgmGn1hjfGyRkmN3krWpFP4',
      tag: `trade ${i18n.t('rank.contractAdr')}`,
      note: ''
    },
    {
      adr: '15YsqAuXeEXVHgm6RVx4oJaAAnhtwqnu3H',
      tag: `unfreeze ${i18n.t('rank.contractAdr')}`,
      note: ''
    }
  ],
  poolist: [
  //   {
  //   adr: '1MWs33SLMN3VPZmqJqBRMHCJUFyornsCDN',
  //   tag: '火币矿池',
  //   note: ''
  // },
    {
    adr: '1JmFaA6unrCFYEWPGRi7uuXY1KthTJxJEP',
    tag: `BTY ${i18n.t('home.fund')}`,
    note: ''
  }, {
    adr: '1Ji3W12KGScCM7C2p8bg635sNkayDM8MGY',
    tag: `BTY ${i18n.t('home.fund')}`,
    note: ''
  }]
}